import styled, { css } from 'styled-components';

import { media } from '@theme/media';
import { FONT_SIZE, typography } from '@theme/font';
import { OFFSET } from '@theme/helpers';

const textStyles = css`
  ${typography({ size: FONT_SIZE.XS })};

  ${media.tablet} {
    ${typography({})};
  }
`;

export const Title = styled.div`
  text-transform: uppercase;
  ${textStyles};
`;

export const Description = styled.div`
  margin-top: ${OFFSET.M};
  ${textStyles};
`;

export const SidebarLinks = styled.div``;
